<app-text class="text-align-center is-size-2 not-found-title">{{errorText | AsyncLang | async}}</app-text>
<img src="assets/images/full-large-error-general.svg">
<app-text class="text-align-center is-size-6 not-found-title">{{'iaq-app.__IAQ_QRCODE_NO_ACCESS' | AsyncLang | async}}</app-text>
